import type { HeaderPaneProps } from 'owa-bootstrap';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "HybridspaceDiagnostics" */ './lazyIndex'),
    { name: 'HybridspaceDiagnostics' }
);

export const HybridspaceDiagnostics: LazyComponent<HeaderPaneProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.HybridspaceDiagnostics);

export const lazyOpenDiagnostics: LazyAction<typeof lazyIndex.openDiagnostics, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.openDiagnostics);
export const lazyOpenFeatureFlags: LazyAction<
    typeof lazyIndex.openFeatureFlags,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openFeatureFlags);
